import { setWaitingHallUpdate } from '%paysera_seat_selection_integration/js/seatings/redux/index';
import selectCurrentOrder
    from '%evp_ticket_frontend/js/redux/currentOrder/selectors/selectCurrentOrder';
import Translator from '%app/js/common/services/translator';
import { openSnackbar, VARIANT_ERROR } from '%app/js/common/components/material/Snackbar';
import checkoutClient from '../service/CheckoutClient';

function submitSeatSelectionStep() {
    return async (dispatch, getState) => {
        const order = selectCurrentOrder(getState());
        if (!order) {
            return;
        }
        dispatch(setWaitingHallUpdate(true));
        let response = null;
        try {
            response = await checkoutClient.completeSeatSelectionStep(order.token);
        } catch (error) {
            if (error.response && error.response.status < 500) {
                dispatch(openSnackbar({
                    variant: VARIANT_ERROR,
                    message: Translator.trans(error.response.data.error_description),
                }));
            } else {
                dispatch(openSnackbar({
                    variant: VARIANT_ERROR,
                    message: Translator.trans('evp_ticket_frontend.cart_error.server_error'),
                }));
            }
            throw error;
        } finally {
            dispatch(setWaitingHallUpdate(false));
            if (response !== null) {
                const { next_step_url: nextStepUrl } = response;
                window.location.href = nextStepUrl;
            }
        }
    };
}

export default submitSeatSelectionStep;
